export default {
    namespaced: true,
    state: {
        horasPonderadas: 3
    },
    mutations: {
        SET_HORASPONDERADAS(state, valor){
            state.horasPonderadas = valor;
        }
    },
    actions: {
        setHorasPonderadas({commit}, acciones){
            let horasPonderadas = 0;
            acciones.forEach((accion) => {
                if (accion.contrato.id !== 10 && accion.contrato.id !== 8) {
                  // Las acciones de contrato "no facturable" y "desarrollo" se ignoran en el cálculo de las horas ponderadas de sistemas
                  horasPonderadas += accion.horasPonderadas;
                }
            });
            commit('SET_HORASPONDERADAS', Math.round(horasPonderadas * 100) / 100);
        }
    }
}